import React, { useEffect, useState } from 'react';
import './EventDetails.css';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import NoCompanyLogo from '../Images/NoCompanyLogo.png';
import loader from '../Images/loader.gif'
import { useDispatch } from 'react-redux';
import { Button, Link, Tooltip, CircularProgress } from '@material-ui/core';
import TwitterIcon from '../Images/twitter.png';
import LinkedInIcon from '../Images/linkedin.webp';
import FacebookIcon from '../Images/facebook-new.png';
import WhatsappIcon from '../Images/WhatsApp_icon.png';
import InstagramIcon from '../Images/instagram-icon.webp';
import CustomAlert from './CustomAlert';
import { MetaTags } from 'react-meta-tags';
import draftToHtml from 'draftjs-to-html';
import { getDownloadUrlFromFullPath, getEventDetailsBasedOnUniqueId, loadInitial } from '../Backend/firebase/events';
import DetailsSkeleton from './DetailsSkeleton';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function AddMetaTags({ record, imageUrl }) {
    return (
        <>
            <div className="wrapper">
                <MetaTags>
                    <meta charSet="utf-8" />
                    <meta name="description" content={record?.eventName} />
                    <meta property="og:description" content={record?.eventName} />
                    <meta property="og:title" content={record?.eventName} />
                    <meta property="og:image" itemprop="image primaryImageOfPage" content={"https://kaipsoolretail.web.app/assets/kaipsool.png"} />
                    <meta property="og:image:height" content="200" />
                    <meta property="og:image:width" content="200" />
                    <meta name="twitter:description" property="og:description" content={record?.eventName} />
                    <meta name="twitter:title" content={record?.eventName} />
                    <meta name="twitter:image" content={"https://kaipsoolretail.web.app/assets/kaipsool.png"} />
                    <meta name="og:url" content={window.location.href} />
                    <title>{record?.eventName}</title>
                    <link rel="image_src" href={"https://kaipsoolretail.web.app/assets/kaipsool.png"} />
                    <link rel="canonical" href={window.location.href} />
                </MetaTags>
            </div>
        </>
    )
}


const MedicalEventsDetails = () => {
    const { uid } = useParams();
    const [eventDetails, setEventDetails] = useState(null);
    const dispatch = useDispatch();
    const history = useHistory();
    const [imageUrl, setImageUrl] = useState('');
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');

    useEffect(() => {
        // Returns the cleanup function
        return () => {
            const metaTag = document.querySelector(`meta[content="Web site created using create-react-app"]`);
            if (metaTag) {
                metaTag.remove();
            }
        }
    }, []);

    useEffect(async () => {
        try {
            const getEventsData = await getEventDetailsBasedOnUniqueId(uid);
            setEventDetails(getEventsData.event);
        } catch(error) {
            console.log("Error Occur in Get Retailer Profile", error)
        }
    }, []);

    const eventSubmission = (eventSubmissionURL) => {
        window.open(eventSubmissionURL, '_blank', 'noopener,noreferrer');
    }

    const viewFranchiseProductList = async (path, name) => {
        var url = await getDownloadUrlFromFullPath(path);
        window.open( url , "_blank", 'noopener,noreferrer')
        // router.push(url)
    };

    return (
        <>
            <div className="container-fluid mb-5">
                <AddMetaTags record={eventDetails} imageUrl={imageUrl} />
                {
                    eventDetails && eventDetails != null ? 
                    <div className="row">
                        <div className="col-lg-10 col-md-10 col-sm-12 mx-auto mt-5">
                            <div className="productDetail mt-5">
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="productDetail__productHead">
                                            {eventDetails?.eventImage ? <div className="eventDetail__companyInfoLogo eventDetail__FranchiseInfoLogo">
                                                    <img src={eventDetails?.eventImage} alt="Store Name" className="img-fluid retailerDetail__companyInfoLogo" />
                                                </div>
                                                : <div className="retailerDetail__companyInitialLogo">
                                                    <div className="logoInitial">{loadInitial(eventDetails.eventName)}</div>
                                                </div>
                                            }
                                        </div><br />
                                    </div>
                                    <div className="col-md-5">
                                        <div className="productDetail__companyInfo">
                                            {eventDetails && <h5 className="MainColor">{eventDetails?.eventName}</h5>}
                                            {eventDetails?.location}
                                            {eventDetails?.eventCategory == "Franchise Events" ? <>
                                                {eventDetails?.city && <p className="productDetail__title">City: <b>{eventDetails?.city}</b></p>}
                                                <p className="productDetail__title">Type: <b>{eventDetails?.eventType}</b></p>
                                                {eventDetails?.phone && <p className="productDetail__title">Contact Number: <a href={`tel:${eventDetails?.phone}`}>+91 {eventDetails?.phone}</a></p>}
                                                {eventDetails?.email && <p className="productDetail__title">Email Id: <a href={`mailto:${eventDetails?.email}`}>{eventDetails?.email}</a></p>}
                                                {eventDetails?.certification && <p className="productDetail__title">Certification: <b>{eventDetails?.certification}</b></p>}
                                                {eventDetails?.yearOfEstablishment && <p className="productDetail__title">Year of Establishment: <b>{eventDetails?.yearOfEstablishment}</b></p>}
                                                {eventDetails?.otherUnites && <p className="productDetail__title">Other Unites: <b>{eventDetails?.otherUnites}</b></p>}
                                            </> : <>
                                                <p className="productDetail__title">Event Type: {eventDetails?.eventType} - {eventDetails?.modeOfEvent}</p>
                                                <p className="productDetail__title">Organizer: {eventDetails?.organizer}</p>
                                                <p className="productDetail__title">Start at <b>{eventDetails?.eventDate?.toDate()?.toDateString()}</b> -  <b>{eventDetails?.eventTime}</b></p>
                                                <p className="productDetail__title">Registration Close at <b>{eventDetails?.registrationClosingDate?.toDate()?.toDateString()}</b></p>
                                            </>}
                                            <div className="col-md-12 mt-4">
                                                <div className="jobDetail__applyJobsShare">
                                                    <div className="jobDetail__socialIcons">
                                                        <a href={`https://wa.me/?text=${window.location.href}`} data-action="share/instagram/share" target="_blank"
                                                            style={{ marginRight: '12px' }}>
                                                            <Tooltip title="Share this post via WhatsApp" placement="top">
                                                                <img src={WhatsappIcon} alt="whatsapp-icon" width="25px" height="25px" />
                                                            </Tooltip>
                                                        </a>
                                                        {/* <a href={`https://wa.me/?text=${window.location.href}`} data-action="share/whatsapp/share" target="_blank"
                                                            style={{ marginRight: '16px' }}>
                                                            <Tooltip title="Share this post via Instagram" placement="top">
                                                                <img src={InstagramIcon} alt="instagram-icon" width="22px" height="22px" />
                                                            </Tooltip>
                                                        </a> */}
                                                        <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}?utm_source=linkedin&utm_medium=social&utm_campaign=linkedin_social_vac_share`} target="_blank"
                                                            style={{ marginRight: '12px' }}>
                                                            <Tooltip title="Share this post via linkedIn" placement="top">
                                                                <img src={LinkedInIcon} alt="linkedin-icon" width="20px" height="20px" />
                                                            </Tooltip>
                                                        </a>
                                                        <a href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}?utm_source=facebook&utm_medium=social&utm_campaign=facebook_social_vac_share`} target="_blank"
                                                            style={{ marginRight: '12px' }}>
                                                            <Tooltip title="Share this post via facebook" placement="top">
                                                                <img src={FacebookIcon} alt="facebook-icon" width="25px" height="25px" />
                                                            </Tooltip>
                                                        </a>
                                                        <a href={`https://twitter.com/intent/tweet?url=${window.location.href}?utm_source=twitter&utm_medium=social&utm_campaign=twitter_social_vac_share&text=${eventDetails?.eventName}`} target="_blank">
                                                            <Tooltip title="Share this post via twitter" placement="top">
                                                                <img src={TwitterIcon} alt="twitter-icon" width="25px" height="25px" />
                                                            </Tooltip>
                                                        </a>
                                                    </div>
                                                </div><br />
                                            </div>
                                            {eventDetails?.eventCategory == "Franchise Events" ? <div className={eventDetails.franchiseAwardsAndCertificatesDocumentPath ? "path_btn" : "path_btn path_full_btn"}>
                                                {eventDetails.franchiseProductListDocumentPath && <div className="mt-4">
                                                    <Button 
                                                        variant="contained" 
                                                        color="primary" className="navbar__btnLogin"
                                                        onClick={()=> viewFranchiseProductList(eventDetails.franchiseProductListDocumentPath)}>
                                                        View Product List
                                                    </Button>
                                                </div>}
                                                {eventDetails.franchiseAwardsAndCertificatesDocumentPath && <div className="mt-4 award">
                                                    <Button 
                                                        variant="contained" 
                                                        color="primary" className="navbar__btnLogin"
                                                        onClick={()=> viewFranchiseProductList(eventDetails.franchiseAwardsAndCertificatesDocumentPath)}>
                                                        View Awards & Certificates
                                                    </Button>
                                                </div>}
                                            </div> : <>
                                                <div className="mt-4">
                                                    <Button 
                                                        variant="contained" 
                                                        color="primary" className="navbar__btnLogin"
                                                        onClick={()=> eventSubmission(eventDetails.eventSubmissionURL)}>
                                                        Register Now
                                                    </Button>
                                                </div>
                                            </>}
                                            <br />
                                        </div>
                                    </div>
                                </div>
                                {(eventDetails?.aboutTheHealthCamp && draftToHtml(JSON.parse(eventDetails?.aboutTheHealthCamp)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">About the Health Camp:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.aboutTheHealthCamp)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.aboutTheFranchiseEvents && draftToHtml(JSON.parse(eventDetails?.aboutTheFranchiseEvents)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">About us:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.aboutTheFranchiseEvents)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.aboutThePharmaEvents && draftToHtml(JSON.parse(eventDetails?.aboutThePharmaEvents)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">About the Pharma Events:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.aboutThePharmaEvents)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.eligibilityCriteria && draftToHtml(JSON.parse(eventDetails?.eligibilityCriteria)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">Eligibility & Criteria:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.eligibilityCriteria)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.sponsorshipDetails && draftToHtml(JSON.parse(eventDetails?.sponsorshipDetails)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">Sponsorship Details:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.sponsorshipDetails)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.termsAndConditions && draftToHtml(JSON.parse(eventDetails?.termsAndConditions)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">Terms And Conditions:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.termsAndConditions)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.eligibilityCriteriaForFranchise && draftToHtml(JSON.parse(eventDetails?.eligibilityCriteriaForFranchise)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">Eligibility criteria for franchise:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.eligibilityCriteriaForFranchise)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.areaRequired && draftToHtml(JSON.parse(eventDetails?.areaRequired)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">Area Required:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.areaRequired)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.targetCities && draftToHtml(JSON.parse(eventDetails?.targetCities)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">Target cities:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.targetCities)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.minimumInvestment && draftToHtml(JSON.parse(eventDetails?.minimumInvestment)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">Minimum Investment:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.minimumInvestment)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.whyUs && draftToHtml(JSON.parse(eventDetails?.whyUs)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">Why Us:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.whyUs)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.eventDescription && draftToHtml(JSON.parse(eventDetails?.eventDescription)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">Others Details:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.eventDescription)) }} />
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div> : <div className="row">
                        <div className="col-lg-10 col-md-10 col-sm-12 mx-auto mt-5">
                            <div className="productDetail mt-5 text-center justify-center">
                                <DetailsSkeleton />
                            </div>
                        </div>
                    </div>
                }
            </div>

            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default MedicalEventsDetails

